import React from "react";
import { Link } from "react-router-dom";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

// Country data
const countries = [
  {
    name: "United States",
    src: "./image/study-abroad/usa.png",
    link: "/study-abroad/united-states",
  },
  {
    name: "Australia", 
    src: "./image/study-abroad/australia.png",
    link: "/study-abroad/australia",
  },
   {
    name: "Canada", 
    src: "./image/study-abroad/canada.png",
    link: "#",
  },
  {
    name: "United Kingdom",
    src: "./image/study-abroad/uk.png",
    link: "/study-abroad/united-kingdom",
  },
  {
    name: "Ireland",
    src: "./image/study-abroad/ireland.png",
    link: "/study-abroad/ireland",
  },
  {
    name: "Europe",
    src: "./image/study-abroad/europe.png",
    link: "/study-abroad/europe",
  },
  {
    name: "New Zealand",
    src: "./image/study-abroad/newzeland.png",
    link: "/study-abroad/new-zealand",
  },
  {
    name: "UAE",
    src: "./image/study-abroad/uae.png",
    link: "#",
  },
];

// Carousel responsiveness
const responsiveCountries = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 4,
  },
  tablet: {
    breakpoint: { max: 1024, min: 600 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 600, min: 0 },
    items: 1,
  },
};

const StudyAbroad = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center px-4 pb-16 mt-10">
         <style>
        {`
          .react-multiple-carousel__arrow {
            margin-left: -45px;
            margin-right: -45px;
          }
          
        `}
      </style>
      <h1 className="text-4xl font-bold text-center text-indigo-700 mb-4">Study Abroad Opportunities</h1>
      <p className="text-center text-gray-600 mb-10 max-w-2xl mx-auto text-lg">
        Discover top international programs, explore countries, and plan your global education journey with FETC.
      </p>

      {/* Country Carousel */}
      <div className="w-full max-w-6xl mb-12">
        <h2 className="text-center text-xl font-bold mb-8">Explore Countries</h2>
        <Carousel
          responsive={responsiveCountries}
          infinite={true}
          autoPlay={true}
          autoPlaySpeed={3000}
          keyBoardControl={true}
          arrows={true}
          showDots={false}
          containerClass="carousel-container"
        >
          {countries.map((country, idx) => {
            const content = (
              <div className="text-center px-5">
                <img
                  src={country.src}
                  alt={country.name}
                  className="max-h-50 mx-auto rounded object-contain"
                />
                <h5 className="mt-2 font-medium mb-5">{country.name}</h5>
              </div>
            );

            return country.link ? (
              <Link to={country.link} key={idx}>
                {content}
              </Link>
            ) : (
              <div key={idx}>{content}</div>
            );
          })}
        </Carousel>
      </div>

      {/* CTA */}
      <div className="mt-8">
        <a
          href="/contact-us"
          className="bg-indigo-600 text-white px-6 py-3 rounded-md font-semibold text-lg hover:bg-indigo-700 transition"
        >
          Apply Now
        </a>
      </div>

      {/* Resources */}
      <div className="edu-privacy-policy-area bg-white mt-10 p-8 rounded-lg shadow-md max-w-4xl w-full">
        <h2 className="text-2xl font-semibold text-indigo-700 mb-6 text-center">
          Helpful Resources
        </h2>
        {[
          { label: "Financial Planning Checklist", url: "/financial-planning-checklist" },
          { label: "Education Loans", url: "/education-loans" },
          { label: "Understanding the Costs of Studying Abroad", url: "/understanding-the-costs-of-studying-abroad" },
          { label: "Road Map for Study Abroad", url: "/road-map-for-study-abroad" },
        ].map((item, i) => (
          <Link
            key={i}
            to={item.url}
            className="block px-4 py-3 bg-indigo-50 rounded-md font-bold text-indigo-700 underline hover:bg-indigo-100 transition mb-2"
          >
            {item.label}
          </Link>
        ))}
      </div>

      {/* Final Text */}
      <p className="mt-10 max-w-3xl mx-auto text-center text-gray-700 text-lg leading-relaxed px-4">
        Unlock a world of opportunities with <span className="font-semibold text-indigo-700">FETC</span>, your trusted partner in pursuing education overseas. Studying abroad is more than just enrolling in a university — it's a <span className="italic font-medium">life-changing journey</span> that shapes your future.
        We're here to guide you every step of the way.
      </p>
    </div>
  );
};

export default StudyAbroad;
